import styled from 'styled-components'
import {
  FONT_SIZE,
  COLOR,
  Z_INDEXS,
  getFontContrastColor,
  IMG,
} from '../../themes'
export const SelectStyle = styled.div`
  position: relative;
  cursor: ${({ disabled }) => disabled };

  .div-search-select {
    border: 1.5px solid ${COLOR.GRAY_5};
    border-radius: 8px;
    box-shadow: none;
    color: ${COLOR.BLACK_6};
    width: auto;
    background-color: ${COLOR.WHITE};
  }

  .icon-select, .icon-sort, .icon-cancel, .icon-cancel-dropdown {
    width: 24px;
    height: 24px;
    cursor: pointer;
  }

  .icon-search-dropdown {
    width: 24px;
    height: 24px;
    vertical-align: middle;
  }

  .input-search-dropdown {
    width: calc(100% - 70px);
    margin-left: 12px;
    border: none;
    outline: none;
    line-height: 1.5;
    font-family: NunitoRegular;
    font-size: 18px;
    font-weight: 400;
    color: ${COLOR.BLACK_6};
    padding: 0 0 3px 0;
    ::placeholder {
      font-size: 18px;
      color: ${COLOR.GRAY_27};
    }
  }

  .div-select-list {
    position: absolute;
    background: ${COLOR.WHITE};
    box-shadow: none;
    border: 1.5px solid ${COLOR.GRAY_5};
    border-radius: 8px;
    z-index: ${Z_INDEXS.LV_1};
    overflow: auto;
  }

  .list-search {
    padding: 0 16px;
    height: 48px;
    line-height: 48px;
    box-sizing: border-box;
    font-family: NunitoRegular;
    font-size: 18px;
    font-weight: 400;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .list-search:hover {
    background: ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
    color: ${({ colorTheme, isNotFound }) => isNotFound ? COLOR.GRAY_3 : getFontContrastColor(colorTheme)};
  }

  .list-search-dis {
    padding: 0 16px;
    height: 48px;
    line-height: 48px;
    box-sizing: border-box;
    font-size: 18px;
    color: ${COLOR.GRAY_3};
  }

  .list-search-dis:hover {
    cursor: not-allowed;
  }

  .empty:hover {
    background: ${COLOR.WHITE};
  }

  .empty {
    color: ${COLOR.GRAY_3};
  }

  .input-search {
    width: 90%;
    margin-left: 16px;
    border: none;
    outline: none;
    line-height: 36px;
    font-family: NunitoRegular;
    font-size: 18px;
    font-weight: 400;
    color: ${COLOR.BLACK_6};
    ::placeholder {
      font-size: 18px;
      color: ${COLOR.BLACK_6};
      font-family: NunitoRegular;
      letter-spacing: 0.5px;
    }
  }

  .icon-cancel {
    width: 16px;
    height: 16px;
    padding-left: 12px;
    margin-right: 6px;
    vertical-align: middle;
  }

  .icon-cancel-dropdown {
    width: 16px;
    height: 16px;
    padding-left: 12px;
    margin-right: 6px;
    vertical-align: middle;
  }

  .icon-sort {
    width: 12px;
    height: 12px;
    vertical-align: middle;
  }

  .disabled,
  .disabled * {
    background-color: ${COLOR.GRAY_2} !important;
    cursor: not-allowed !important;
    color: ${COLOR.GRAY_24};

  }
  }
  .red {
    color: red;
  }
  .yellow {
    color: ${COLOR.YELLOW_1};
  }
  .grey {
    color: #DBDBDB;
  }

  .list {
    display: flex;
    padding: 12;
    flex-direction: row;
    align-items: center;
  }

  .circle-busy {
    margin-left: auto;
    background-color: ${props=>props.colorTheme? props.colorTheme : COLOR.GOLD_1};
    width: 12px;
    height: 12px;
    border-radius: 50%;
    border: solid 1px;
  }

  .circle-available {
    background-color: ${COLOR.WHITE};
    border: solid 1px;
    border-radius: 50%;
    margin-left: auto;
    width: 12px;
    height: 12px;
  }

  .list-search-label {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    min-width: 0;
  }

  .checkin-icon {
    flex-shrink: 0;
    width: 16px;
    height: 16px;
    background-color: ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
    mask: url(${IMG['ic_require-checkin.svg']}) center / contain no-repeat;
    -webkit-mask: url(${IMG['ic_require-checkin.svg']}) center / contain no-repeat;
  }

  .list-search:hover .checkin-icon {
    background-color: ${({ colorTheme }) => getFontContrastColor(colorTheme)};
  }

  .div-search-select {
    position: relative;
  }

  .field-checkin-icon {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    pointer-events: none;
  }

  .disabled .checkin-icon {
    background-color: ${({ colorTheme }) => colorTheme || COLOR.GOLD_1} !important;
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  input[type=number] {
    -moz-appearance: textfield;
  }
`

